module.exports = __webpack_public_path__ + "static/media/vestas.f69b6270.png";